import apiService from "../common/commonApi";

export const newLeaveRequest = {};

newLeaveRequest.listEmployeeAndManagerLeader = async (param) => {
    return apiService.Get("getEmployeeAndManagerLeader", param);
};

newLeaveRequest.listLeaveType = async (param) => {
    return apiService.Get("getLeaveTypes", param);
};

newLeaveRequest.listAvailableTime = async (param) => {
    return apiService.Get("getAvailableTime", param);
};

newLeaveRequest.createLeaveDay = async (param) => {
    return apiService.Post("createLeaveDay", param)
}
